(function(angular) {
    'use strict';


    angular.module('app').factory('MultiDownloadModal', [
        '$uibModal',
        MultiDownloadModal
    ]);

    angular.module('app').controller('MultiDownloadModalCtrl', [
        '$uibModalInstance',
        'FacilityVisitRepository',
        'selectedList',
        'sourceList',
        'all',
        'sortBy',
        'patientId',
        'externalId',
        MultiDownloadModalCtrl
    ]);

    function MultiDownloadModal(
        $modal
    ) {
        return {
            openMultiModal: openMultiModal,
        };

        function openMultiModal(multiVisitObj) {
            var selectedList = multiVisitObj.selectedList;
            var sourceList = multiVisitObj.sourceList;
            var all = multiVisitObj.all;
            var sortBy = multiVisitObj.sortBy;
            var patientId = multiVisitObj.patientId;
            var externalId = multiVisitObj.externalId;

            var multiModal = $modal.open({
                backdrop: 'static',
                templateUrl: '/app/views/modals/multiDownloadModal.html',
                windowClass: 'modal-full',
                controller: 'MultiDownloadModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    selectedList: function() { return selectedList; },
                    sourceList: function() { return sourceList; },
                    all: function() { return all; },
                    sortBy: function() { return sortBy; },
                    patientId : function() { return patientId; },
                    externalId : function() { return externalId; },
                }
            });

            return multiModal.result;
        }
    }

    function MultiDownloadModalCtrl(
        $modalInstance,
        FacilityVisitRepository,
        selectedList,
        sourceList,
        all,
        sortBy,
        patientId,
        externalId
    ) {
        var vm = this;

        vm.selectedList = selectedList;
        vm.sourceList = sourceList;
        vm.all = all;
        vm.sortBy = sortBy;
        vm.patientId = patientId;
        vm.externalId = externalId;
        vm.Downloading = false;

        vm.cancel = cancel;
        vm.downloadMultipleVisits = downloadMultipleVisits;

        function cancel() {
            vm.selectedList = [];
            $modalInstance.dismiss();
        }

        function downloadMultipleVisits() {
            vm.Downloading = true;
            var visitIds = [];
            _.forEach(vm.selectedList, function(item){
                visitIds.push(item.VisitId);
            });

            return FacilityVisitRepository.getPdfsByVisits(vm.patientId, visitIds)
                .then(function (data){
                    if(data === null){
                        $modalInstance.close('error');
                    }
                    else{
                        $modalInstance.close('success');
                    }
                    return {
                        Data: data.Data,
                        Extension: 'pdf',
                        FileName: 'ID' + vm.externalId + '_' + 'Visits',
                    };
                });
        }
    }
})(window.angular);
